'use strict';

(function (angular) {
  angular.module('zp').directive('sidebarFixed', sidebarFixedDirective);

  /**@ngInject */
  function sidebarFixedDirective($window, $rootScope) {
    var dir = {
      restrict: 'A',
      link: link,
      scope: {
        trigger: '@',
        fromTop: '@',
        zIndex: '@'
      }
    };

    return dir;

    function link(scope, element) {
      var fixed = false;

      var topMargin = 0;

      /**Activate */
      (function () {
        angular.element($window).bind('scroll', function () {
          if ($rootScope.lowResolutionMode) {
            return;
          }
          if (!fixed && !angular.element(element).visible()) {
            fixBasket();
          }

          if (fixed && angular.element(scope.trigger).visible()) {
            releaseBasket();
          }
        });
      })();

      function fixBasket() {
        topMargin = element.css('margin-top');
        fixed = true;
        element.css('top', scope.fromTop + 'px');
        element.css('left', element.offset().left + 'px');
        element.css('width', element.css('width'));
        element.css('position', 'fixed');
        element.css('z-index', scope.zIndex);
        element.css('margin-top', '0px');
        element.css('background', '#fdf6ec');
      }

      function releaseBasket() {
        fixed = false;
        element.css('position', 'static');
        element.css('background', 'transparent');
        if (topMargin) {
          element.css('margin-top', topMargin);
        }
      }
    }
  }
})(window.angular);